module.exports = __webpack_public_path__ + "static/media/1017063.93d0b77a.png";